 /*================ Footer Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('sliderFactory', sliderFactory);

    sliderFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', 'VarientService'];

    function sliderFactory($http, $rootScope, $log, vppConfig, VarientService){
      return function(){
        var noVarient = "";
        var getVarient = VarientService.getVarientName();
        if(getVarient){
         var  thisVarient = getVarient + "-";
        }else {
          var thisVarient = noVarient;
        }
        // need to switch Url var below to switch file paths for varients 
        //var Url = vppConfig.contentSliderPath + thisVaient + "slider.json";
        var Url = vppConfig.contentSliderPath + "slider.json";
        var promise = $http.get(Url).then(function(data){
        return data;
      }, function errorCallback (data){
        return data;
      })

      return promise;
      }
  };